import { Box, Flex, HStack, Link, Text } from '@chakra-ui/react'
import { MerchantPayment, MerchantStore } from '@prisma/client'
import BigNumber from 'bignumber.js'
import { DateTime } from 'luxon'
import { PaymentStatus } from '../../../components/PaymentStatus'
import { formatDateForDisplay, formatFloatForDisplay } from '../../../utils/utils'
import { tokenToMintMap } from '../../pay/payUtils'
import { labelStyle, subLabelStyle } from '../../common/commonStyles'

interface Props {
  i: number
  transaction: MerchantPayment & {
    store: MerchantStore
  }
}

export const TransactionsListItem: React.FC<Props> = ({ i, transaction }) => {
  const inputTokenConfig = tokenToMintMap[transaction.token]
  if (!transaction.tokenAmount) return <></>
  const inputAmount = new BigNumber(transaction.inputPaymentAmount ?? 0).dividedBy(
    10 ** inputTokenConfig.decimals
  )
  const payoutTokenConfig = transaction.targetToken ? tokenToMintMap[transaction.targetToken] : null
  const payoutAmount = transaction.targetToken && payoutTokenConfig ? new BigNumber(
    transaction.tokenAmount ?? 0
  ).dividedBy(
    10 ** payoutTokenConfig.decimals
  ) : new BigNumber(0)

  return (
    <Flex
      pt={i == 0 ? 0 : '1rem'}
      mt={i == 0 ? 0 : '1rem'}
      borderTop={i == 0 ? 'none' : '1px solid #eee'}
      key={transaction.id}
      justifyContent={'space-between'}
      alignItems='center'
    >
      <Box>
        <Text display='inline' fontSize={'.875rem'} fontWeight={500} color='#000'>
          Tx-No: {transaction.number} /{' '}
        </Text>
        {transaction.txId && (
            <Text display='inline' fontSize={'.75rem'}>
              Tx-Ref:{' '}
              <Link
                textDecoration='underline'
                target='_blank'
                href={`https://solscan.io/tx/${transaction.txId}`}
              >
                {transaction.txId.substring(0, 8)}...
              </Link>
            </Text>
          )}
        <HStack mt='.4rem' spacing='1.4rem'>
          <Text fontWeight={500} fontSize='.875rem' color='#676767'>
            {formatDateForDisplay(transaction.createdAt)}
          </Text>
          <Text style={subLabelStyle} fontSize='.75rem' ml='1.2rem'>
            Store: {transaction.store.storeName}
          </Text>
          <PaymentStatus status={transaction.status} />
        </HStack>
        {transaction.purchaseNoteByMerchant && (<HStack mt='.4rem' spacing='2rem'>
          <Text fontSize={'.7rem'} fontWeight={500} color='#000'>
            Purchase Note: {transaction.purchaseNoteByMerchant}
          </Text>
        </HStack>)}
      </Box>
      <Box textAlign={'right'}>
        <Text style={labelStyle}>
          {transaction.referenceValue?.toFixed(2)} {transaction.referenceCurrency}
        </Text>

        <Text style={subLabelStyle} mt='.25rem'>
          {transaction.paymentType === 'SWAP' ? 'Paid In:' : ''} {formatFloatForDisplay(inputAmount.toNumber())} {transaction.token} {transaction.paymentType === 'SWAP' ? ` / Received: ${payoutAmount.toFixed(2)} ${transaction.targetToken}`: ''}
        </Text>
      </Box>
    </Flex>
  )
}
